import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { fetchNotifications, resetNotifications } from '../../reducers/notifications/notifications.actions';
import {
  selectIsFetchingNotifications,
  selectNotificationCurrentPage,
  selectNotificationLastPage,
  selectNotifications,
} from '../../reducers/notifications/notifications.selectors';
import Loader from '../../components/Loader';
import notificationTypes from '../../constants/notificationTypes';
import Notification from './Notification';
import API from 'API';
import { useTranslation } from 'react-i18next';
const Notifications = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const notifications = useSelector(selectNotifications);
  const isFetching = useSelector(selectIsFetchingNotifications);
  const lastPage = useSelector(selectNotificationLastPage);
  const page = useSelector(selectNotificationCurrentPage);
  const { t, i18n } = useTranslation();
  const list = useMemo(
    () => notifications.filter(item => notificationTypes.hasOwnProperty(item.type)),
    [notifications]
  );

  useEffect(() => {
    return () => API.post('/notifications/mark-as-read');
  }, [])

  useEffect(() => {
    if (!isFetching) {
      dispatch(fetchNotifications());
    }
    return () => {
      dispatch(resetNotifications());
    };
  }, [location]);

  const observer = useRef();
  const lastPostElementRef = useCallback(
    node => {
      if (isFetching || lastPage === page) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver(post => {
        if (post[0].isIntersecting) {
          dispatch(fetchNotifications(page + 1));
        }
      });
      if (node) observer.current.observe(node);
    }, [isFetching]);
  return (
    <div className={'py-4'} style={{ minHeight: '100%' }}>
      <ul className="list-group list-group-flush">
        {list.map((el, index) => (
          <div key={index} ref={(list.length === index + 1 ? lastPostElementRef : null)}>
            <Notification notification={el} />
          </div>
        ))} 
        
        {!isFetching && list.length === 0 && 
        <p className='notification-not-found'>{t('Nothing yet')}</p>}

        {(page < lastPage || (page === lastPage && isFetching)) && (
          <Loader isLoadin={isFetching} height={36} size={28} />
        )}
      </ul>
    </div>
  );
};

export default Notifications;
